<template>
  <div>
    <div>
      <div
        class="login_div"
        :style="
          scroll >= 500
            ? 'box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);color:#333;background:#fff;'
            : ''
        "
      >
        <div class="left">
          <img src="../assets/stylus/image/logo.png" />
        </div>
        <div class="right">
          <p
            @click="about('/login')"
            :class="router_type == 'login' ? 'active_home' : ''"
          >
            首页
          </p>
          <p
            @click="about('/edit_home')"
            :class="router_type == 'Programming community' ? 'active_home' : ''"
          >
            编程社区
          </p>
          <p
            @click="about('/about')"
            :class="router_type == 'match' ? 'active_home' : ''"
          >
            赛事中心
          </p>
          <p :class="router_type == 'study' ? 'active_home' : ''">
            <a target="_blank" href="http://oj.cgyounger.com/">信奥学习</a>
          </p>
          <p
            @click="about('/about')"
            :class="router_type == 'about' ? 'active_home' : ''"
          >
            关于程果
          </p>
          <el-dropdown
            v-if="userInfo.Id"
            trigger="click"
            @command="handleCommand"
          >
            <span class="el-dropdown-link">
              <img src="../assets/stylus/image/head.png" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="后台管理">后台管理</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <p v-else class="active_p" @click="handleSelect">登录后台系统</p>
        </div>
      </div>

      <div class="bg_div">
        <div class="text_div">
          <h3>程果少儿编程</h3>
          <div class="typer-content">
            <p class="typer-static">用编程&nbsp;</p>
            <!-- 动态变化的内容-->
            <p class="typer-dynamic">
              <span class="cut">
                <span
                  class="word"
                  v-for="(letter, index) in words"
                  :key="index"
                  >{{ letter }}</span
                >
              </span>
            </p>
          </div>
        </div>

        <div class="mask"></div>
        <div v-for="(item, index) in officialList" :key="index">
          <video
            v-if="item.Mark == '官网banner'"
            muted="muted"
            loop
            autoplay="autoplay"
            :src="item.File"
          >
            <!-- <source src="../assets/stylus/image/sp.mp4" type="video/mp4" /> -->
          </video>
        </div>
      </div>

      <div class="choice_div">
        <h1>国际化的教学理念</h1>
        <div class="border_div"></div>
        <p style="font-size:14px;">
          引进国外先进的教育理念，结合中国国情与孩子们的成长环境进行创新，落地成适合中国孩子的机器人编程课程体系
        </p>

        <ul>
          <li>
            <div
              class="top_img"
              style="padding:12px;box-shadow: 0 2px 12px 0 rgba(249, 180, 28, 0.5)"
            >
              <img src="../assets/stylus/image/ICON_1.png" alt="" />
            </div>
            <h2>PBL项目制学习</h2>
            <p>基于PBL问题导向式学习，拒绝传统填鸭式教育</p>
          </li>
          <li>
            <div
              class="top_img"
              style="padding:12px;box-shadow: 0 2px 12px 0 rgba(180, 81, 255, 0.5)"
            >
              <img src="../assets/stylus/image/ICON_2.png" alt="" />
            </div>
            <h2>对标美国CSTA标准</h2>
            <p>课程按照美国最权威的CSTA计算机科学标准K12阶段而设计</p>
          </li>
          <li>
            <div
              class="top_img"
              style="padding:12px;box-shadow: 0 2px 12px 0 rgba(65, 171, 252, 0.5)"
            >
              <img src="../assets/stylus/image/ICON_3.png" alt="" />
            </div>
            <h2>6-8人精品小班</h2>
            <p>小而精的机器人编程课堂，每个孩子都可以更加出彩</p>
          </li>
          <li>
            <div
              class="top_img"
              style="padding:12px;box-shadow: 0 2px 12px 0 rgba(252, 92, 92, 0.5)"
            >
              <img src="../assets/stylus/image/ICON_4.png" alt="" />
            </div>
            <h2>团队协作</h2>
            <p>同学之间，学生与老师之间，帮助孩子培养良性的学习循环</p>
          </li>
        </ul>
      </div>

      <div class="choice_div two_div">
        <h1>深受社会认可 助力教育普惠</h1>
        <div class="border_div"></div>
        <p>抓住6-15岁思维成长黄金期，提升孩子未来核心竞争力</p>

        <ul class="two_ul">
          <div
            v-for="(item, index) in officialList"
            :key="index"
            :style="item.Mark == '深受社会认可' ? '' : 'display:none'"
          >
            <li v-if="item.Mark == '深受社会认可'">
              <div
                class="top_img"
                style="width: 100%;height:220px;border-radius:4px;background:#ccc;"
              >
                <img :src="item.File" />
              </div>
              <p>{{ item.SubText }}</p>
            </li>
          </div>
        </ul>
      </div>

      <div class="choice_div three_div">
        <h1>优秀教师保证</h1>
        <div class="border_div"></div>
        <!-- <p>
          程果少儿编程的教研团队在教育背景方面60%研究生及以上学历，55%来自北京大学、清华大学等重点大
        </p> -->

        <el-carousel :interval="4000" type="card">
          <div v-for="(item, index) in officialList" :key="index">
            <el-carousel-item
              v-if="item.Mark == '清北优秀教师保证'"
              style="background:#fffdf1;"
            >
              <img :src="item.File" style="height:100%; " />
            </el-carousel-item>
          </div>
        </el-carousel>
      </div>

      <div class="choice_div four_div">
        <h1>大赛成绩</h1>
        <div class="border_div"></div>
        <p style="margin-bottom: 40px;">1000+大赛获奖学员成绩</p>

        <div v-for="(item, index) in officialList" :key="index">
          <div
            class="fourBottom_div"
            style="box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)"
            v-if="item.Mark == '大赛成绩'"
          >
            <div class="left">
              <img :src="item.File" style="width:100%;" />
            </div>
            <div class="right">
              <h4>{{ item.Text }}</h4>
              <p>
                {{ item.SubText }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="choice_div five_div">
        <h1>科技驱动 培养青少年素质成长</h1>
        <div class="border_div"></div>

        <div class="fourBottom_div" style="width: 100%;">
          <div class="left">
            <img src="../assets/stylus/image/morton.jpeg" style="width:100%;" />
          </div>
          <div class="right">
            <ul>
              <li>
                <img src="../assets/stylus/image/foster_icon1.png" />
                <h3 style="font-size:18px;">
                  创新教学模式，依据儿童成长规律，构建学习模型，教学范式，使用独创学习天梯pk系统，全面激发孩子学习兴趣。
                </h3>
              </li>
              <li>
                <img src="../assets/stylus/image/foster_icon2.png" />
                <h3 style="font-size:18px;">
                  创新教学模式，依据儿童成长规律，构建学习模型，教学范式，使用独创学习天梯pk系统，全面激发孩子学习兴趣。
                </h3>
              </li>
              <li>
                <img src="../assets/stylus/image/foster_icon3.png" />
                <h3 style="font-size:18px;">
                  年累计20万+课时教学经验，打造AI老师系统、智能教学系统和智能师训系统。
                </h3>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div
        class="choice_div five_div"
        style="background:#f8f8f8;padding-bottom: 14px;"
      >
        <h1>荣誉奖项</h1>
        <div class="border_div"></div>
        <p>程果会始终以“做中国最受家长信赖的少儿编程品牌”为愿景，坚持初心！</p>

        <el-carousel
          trigger="click"
          direction="vertical"
          height="360px"
          style="width:90%;margin:100px auto;margin-bottom:0;"
        >
          <el-carousel-item>
            <div class="left_carousel">
              <div v-for="(item, index) in officialList" :key="index">
                <img
                  v-if="item.Mark == '荣誉奖项1'"
                  :src="item.File"
                  style="width:100%;"
                />
              </div>
            </div>
            <div class="left_carousel">
              <div v-for="(item, index) in officialList" :key="index">
                <img
                  v-if="item.Mark == '荣誉奖项2'"
                  :src="item.File"
                  style="width:100%;"
                />
              </div>
            </div>
            <div class="left_carousel">
              <div v-for="(item, index) in officialList" :key="index">
                <img
                  v-if="item.Mark == '荣誉奖项3'"
                  :src="item.File"
                  style="width:100%;"
                />
              </div>
            </div>
            <div class="left_carousel">
              <div v-for="(item, index) in officialList" :key="index">
                <img
                  v-if="item.Mark == '荣誉奖项4'"
                  :src="item.File"
                  style="width:100%;"
                />
              </div>
            </div>
          </el-carousel-item>

          <el-carousel-item>
            <div class="left_carousel">
              <div v-for="(item, index) in officialList" :key="index">
                <img
                  v-if="item.Mark == '荣誉奖项5'"
                  :src="item.File"
                  style="width:100%;"
                />
              </div>
            </div>
            <div class="left_carousel">
              <div v-for="(item, index) in officialList" :key="index">
                <img
                  v-if="item.Mark == '荣誉奖项6'"
                  :src="item.File"
                  style="width:100%;"
                />
              </div>
            </div>
            <div class="left_carousel">
              <div v-for="(item, index) in officialList" :key="index">
                <img
                  v-if="item.Mark == '荣誉奖项7'"
                  :src="item.File"
                  style="width:100%;"
                />
              </div>
            </div>
            <div class="left_carousel">
              <div v-for="(item, index) in officialList" :key="index">
                <img
                  v-if="item.Mark == '荣誉奖项8'"
                  :src="item.File"
                  style="width:100%;"
                />
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>

      <div
        class="choice_div two_div"
        style="background:#fff;padding-top: 46px;padding-bottom: 50px;"
      >
        <h1>合作学校</h1>
        <div class="border_div"></div>
        <ul class="cooperation_ul">
          <li
            v-for="(item, index) in officialList"
            :key="index"
            style="margin-bottom: 6px;"
            :style="item.Mark == '合作学校' ? '' : 'display:none'"
          >
            <div>
              <img :src="item.File" />
            </div>
          </li>
        </ul>
      </div>

      <fotter></fotter>

      <el-dialog
        :visible.sync="login_dialog"
        width="40%"
        :close-on-click-modal="false"
      >
        <span slot="title" class="dialog-footer">
          <el-tabs v-model="activeName">
            <el-tab-pane label="登录" name="login">
              <el-form
                ref="form_ref"
                :model="login_form"
                :rules="rules"
                label-width="0px"
                class="login_from"
              >
                <!-- 用户名 -->
                <el-form-item prop="username">
                  <el-input
                    v-model="login_form.username"
                    prefix-icon="iconfont icon-user"
                    placeholder="请输入用户名"
                  >
                    <i slot="prefix" class="el-icon-user"></i>
                  </el-input>
                </el-form-item>
                <!-- 密码 -->
                <el-form-item prop="password">
                  <el-input
                    v-model="login_form.password"
                    type="password"
                    prefix-icon="iconfont icon-3702mima"
                    placeholder="请输入密码"
                    show-password
                  >
                    <i slot="prefix" class="el-icon-goods"></i>
                  </el-input>
                </el-form-item>
                <!-- 按钮区域 -->
                <el-form-item class="but"></el-form-item>
              </el-form>
            </el-tab-pane>

            <el-tab-pane label="注册" name="register">
              <el-form
                ref="form_register"
                :model="register_form"
                :rules="rules"
                label-width="90px"
                class="login_from"
                label-position="right"
              >
                <el-form-item label="校区选择" prop="school_id">
                  <el-select
                    v-model="register_form.school_id"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in schoolData"
                      :key="item.Id"
                      :label="item.Name"
                      :value="item.Id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="用户" prop="username">
                  <el-input
                    v-model="register_form.username"
                    placeholder="请输入用户名"
                  ></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password">
                  <el-input
                    v-model="register_form.password"
                    type="password"
                    placeholder="请输入密码"
                  ></el-input>
                </el-form-item>
                <el-form-item label="姓名" prop="nickname">
                  <el-input
                    v-model="register_form.nickname"
                    placeholder="请输入姓名"
                  ></el-input>
                </el-form-item>
                <el-form-item label="手机" prop="phone">
                  <el-input
                    v-model="register_form.phone"
                    placeholder="请输入手机号"
                  ></el-input>
                </el-form-item>
                <el-form-item label="email">
                  <el-input
                    v-model="register_form.email"
                    placeholder="请输入邮箱"
                  ></el-input>
                </el-form-item>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </span>

        <span slot="footer">
          <el-button
            type="primary"
            @click.native="submitForm"
            @keypress.native.enter="submitForm"
            style="width: 100%; font-weight: 400;"
            >{{ activeName == "login" ? "登录" : "注册" }}</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { register_stu, login, get_userRole_api } from "@/api/login.js";
import { userInfo } from "@/api/home.js";
import { getSchool } from "@/api/admin.js";
import { get_official_api } from "@/api/homePage.js";
import { post_image_url_api } from "@/api/resources.js";
import { mapGetters } from "vuex";
import store from "../store";
import fotter from "../view/components/fotter.vue";

export default {
  computed: {
    ...mapGetters(["userInfo"]),
  },
  components: {
    fotter,
  },
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    return {
      activeIndex: "",
      login_dialog: false,
      rules: {
        // 验证用户名是否合法
        username: [
          { required: true, message: "请输入登录名称", trigger: "blur" },
        ],
        // 验证密码是否合法
        password: [
          { required: true, message: "请输入用户密码", trigger: "blur" },
        ],
        school_id: [
          { required: true, message: "请选择校区", trigger: "change" },
        ],
        nickname: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        phone: [{ required: true, validator: checkPhone, trigger: "blur" }],
      },
      //登录
      login_form: {
        username: "",
        password: "",
      },
      //注册
      register_form: {
        school_id: "",
        avatar: "",
        email: "",
        password: "",
      },
      activeName: "",
      loading: false,
      words: [], //字母数组push，pop的载体
      router_type: this.$route.name,
      scroll: "",
      officialList: [],
      str: "连接宇宙让孩子同步 NASA 技术探索星际! ", //str初始化
      letters: [], //str分解后的字母数组
      order: 1, //表示当前是第几句话
      officialstr: "",
      schoolData: [],
    };
  },

  created() {
    get_official_api().then((response) => {
      let value = response.data;
      value.forEach((v) => {
        post_image_url_api([v.File]).then((res) => {
          v.File = window.location.protocol + "//" + res.data[0];
        });

        if (v.Mark == "官网banner") {
          this.officialstr = v.SubText;
        }
      });
      this.officialList = value;
    });

    //获取学校
    getSchool().then((res) => {
      this.schoolData = res.data;
    });
  },

  watch: {
    //监听order值的变化，改变str的内容
    order() {
      if (this.order % 4 == 1) {
        this.str = "让孩子无所不能！";
      } else if (this.order % 4 == 2) {
        this.str = this.officialstr;
      } else if (this.order % 4 == 3) {
        this.str = "玩懂数学，让孩子用运算发现生活里的秘密！";
      } else {
        this.str = "激发创造力，随处都是孩子的实验基地！";
      }
      if (this.order >= 5) {
        this.str = "让孩子无所不能！";
      }
    },
  },

  mounted() {
    //页面初次加载后调用begin()开始动画
    this.begin();
    window.addEventListener("scroll", this.menu, true);
  },

  methods: {
    menu() {
      this.scroll = document.documentElement.scrollTop;
    },

    handleSelect(key) {
      this.login_dialog = true;
      this.activeName = "login";
      if (this.$refs.form_ref !== undefined) {
        this.$refs.form_ref.clearValidate();
      }
    },

    // 点击登录/注册按钮，
    submitForm() {
      if (this.activeName == "login") {
        this.$refs.form_ref.validate((valid) => {
          if (valid) {
            const loading = this.$loading({
              lock: true,
              text: "Loading",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)",
            });

            login(this.login_form)
              .then((res) => {
                userInfo().then((response) => {
                  // 获取用户角色
                  get_userRole_api().then((value) => {
                    if (value.data.length) {
                      this.$message.success("登录成功！");
                      response.data.user_role = value.data;
                      window.sessionStorage.setItem("token", res.data.token);
                      sessionStorage.setItem("campus", JSON.stringify("登录"));
                      store.dispatch("current/campus", "登录");
                      this.login_dialog = false;
                      value.data.forEach((v) => {
                        if (v.Subject.Name == "HEADMASTER") {
                          this.$router.push({
                            path: "/course_info",
                            query: { type: "login_s" },
                          });
                        } else if (v.Subject.Name == "STUDENT") {
                          this.$router.push({
                            path: "/select_course",
                            query: { type: "login_s" },
                          });
                        }
                      });
                    } else {
                      response.data.user_role = false;
                      this.$message.error("该用户未分配角色，禁止访问！");
                      loading.close();
                    }

                    loading.close();
                    store.dispatch("user/userInfo", response.data);
                  });
                });
              })
              .catch(() => {
                loading.close();
              });
          }
        });
      } else {
        this.$refs.form_register.validate((valid) => {
          if (valid) {
            const loading = this.$loading({
              lock: true,
              text: "Loading",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)",
            });

            //注册接口
            toString(this.register_form.phone);
            register_stu(this.register_form.school_id, this.register_form)
              .then((res) => {
                loading.close();
                this.$message.success("注册成功！");
                this.activeName = "login";
                this.login_form.username = this.register_form.username;
                this.login_form.password = this.register_form.password;
                this.submitForm();
                this.register_form = {};
              })
              .catch(() => {
                loading.close();
              });
          }
        });
      }
    },

    handleAvatarSuccess(res, file) {
      this.register_form.avatar = URL.createObjectURL(file.raw);
    },

    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },

    //关于程果
    about(type) {
      if (type == "/edit_home") {
        if (!this.userInfo.Id) {
          this.$message.error("请登录账号访问！");
          this.login_dialog = true;
          return false;
        }
      }

      this.$router.push({ path: type });
    },

    //开始输入的效果动画
    begin() {
      this.letters = this.str.split("");
      for (var i = 0; i < this.letters.length; i++) {
        setTimeout(this.write(i), i * 100);
      }
    },
    //开始删除的效果动画
    back() {
      let L = this.letters.length;
      for (var i = 0; i < L; i++) {
        setTimeout(this.wipe(i), i * 50);
      }
    },
    //输入字母
    write(i) {
      return () => {
        let L = this.letters.length;
        this.words.push(this.letters[i]);
        let that = this;
        /*如果输入完毕，在4s后开始删除*/
        if (i == L - 1) {
          setTimeout(function() {
            that.back();
          }, 5000);
        }
      };
    },
    //擦掉(删除)字母
    wipe(i) {
      if (this.order >= 5) {
      } else {
        return () => {
          this.words.pop(this.letters[i]);
          /*如果删除完毕，在300ms后开始输入*/
          if (this.words.length == 0) {
            this.order++;
            let that = this;
            setTimeout(function() {
              that.begin();
            }, 1000);
          }
        };
      }
    },

    handleCommand(item) {
      if (item == "后台管理") {
        this.userInfo.user_role.forEach((v) => {
          if (v.Subject.Name == "HEADMASTER") {
            this.$router.push({
              path: "/course_info",
              query: { type: "login_s" },
            });
          } else if (v.Subject.Name == "STUDENT") {
            this.$router.push({
              path: "/select_course",
              query: { type: "login_s" },
            });
          }
        });
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.login_from {
  margin-top: 12px;
}

>>>.el-dialog__body {
  padding: 0;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  border: 1px solid #eee;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.bg_div {
  height: 500px;
  background: #ccc;
  position: relative;
  overflow: hidden;

  .text_div {
    position: absolute;
    left: 14%;
    top: 36%;
    z-index: 3;
    color: #fff;
    font-weight: 300;
    width: 80%;

    h3 {
      font-size: 20px;
      padding: 12px;
    }

    p {
      font-size: 48px;
      padding: 3px;
    }
  }

  .mask {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: #000;
    opacity: 0.4;
  }

  video {
    width: 100%;
  }
}

.choice_div {
  background: #fff;
  padding-top: 100px;

  h1 {
    text-align: center;
    line-height: 1.2;
    font-size: 36px;
  }

  .border_div {
    background: #ff8d1a;
    height: 2px;
    width: 50px;
    margin: 20px auto;
  }

  p {
    text-align: center;
    color: #999;
  }

  ul {
    margin:0 auto;
    margin-top: 50px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;

    li {
      width: 45%;
      padding: 20px;
      margin-bottom: 26px;

      .top_img {
        width: 90px;
        height: 90px;
        margin: 0 auto;
        border-radius: 45px;
        overflow: hidden;
        img {
          height: 100%;
        }
      }

      h2 {
        text-align: center;
        font-size: 26px;
        font-size: #444;
        padding: 20px;
      }

      p {
        color: #999;
        font-size: 18px;
      }
    }
  }
}

.two_div {
  background: #f8f8f8;
  padding-top: 50px;

  .two_ul {
    li {
      width: 100%;
      p {
        margin-top: 24px;
      }
    }
  }
}

.three_div {
  background: #ffffff;
  padding-top: 50px;
}

.four_div {
  background: #f8f8f8;
  padding-top: 46px;
  padding-bottom: 50px;
}

.fourBottom_div {
  width: 80%;
  padding: 20px;
  background: #fff;
  margin: 0px auto;
  display: flex;
  justify-content: space-around;
  border-radius: 6px;

  .left {
    width: 40%;
    overflow: hidden;
    border: 1px solid #ff8d1a;
  }

  .right {
    width: 50%;

    h4 {
      font-size: 30px;
      color: #444;
    }

    p {
      text-align: left;
      color: #8f8f8f;
      font-size: 16PX;
      margin-top: 30px;
      text-indent: 2em;
      line-height: 22px;
    }
  }
}

.five_div {
  background: #fff;
  padding-top: 44px;

  .left {
    border: none;
  }

  .right {
    ul {
      margin-top: 0;

      li {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        img {
          width: 66px;
          height: 66px;
          border-radius: 33px;
        }

        h3 {
          margin-left: 20px;
          line-height: 30px;
          font-size: 24px;
          color: #8f8f8f;
        }
      }
    }
  }
}

.cooperation_ul {
  width: 90%;
  margin: 0 auto;

  li {
    width: 24.5% !important;
    padding: 12px;
    background: #eee;
    border-radius: 4px;

    img {
      margin: 0 auto;
    }
  }
}

.left_carousel {
  width: 22%;
  // height: 100%;
}

.right_carousel {
  float: right;
  width: 20%;
  height: 100%;
  margin-right: 6%;
  padding: 20px;
}

.el-carousel {
  margin-top: 100px;
  padding-bottom: 34px;
}

.el-carousel__item:nth-child(2n) {
  background-color: #eee;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #eee;
}

.active_home {
  border-bottom: 2px solid #ff8d1a;
}

.login_div {
  position: fixed;
  top: 0;
  width: 100%;
  color: #fff;
  padding: 0px 16px 0px 16px;
  font-size: 12px;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: space-between;

  p {
    float: right;
    cursor: pointer;
    padding: 10px;
  }

  .left {
     img {
       width:30%;
     }
  }

  .right {
    display: flex;
    p {
      padding-left: 0;
      padding-right: 0;
      margin-right: 12px;
    }
    .active_p {
    color:#fff;
    border-radius: 20px;
    background: #ff8d1a;
    font-weight: 500;
    margin-left: 12px;
    padding:12px;
  }
    img {
      width:30px;
      cursor: pointer;
    }
  }
}

.login_div_active {
  background: #fff;
  color: #333;
}

.el-carousel__item {
  background-color: #e8e6e6;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}

.el-backtop {
  background:none;
}

.backtop_img {
  box-shadow: rgb(252 92 92 / 50%) 0px 2px 12px 0px;
  border-radius: 22px;
  position: relative;
  top: 0px;
  -webkit-animation: myfirst 2.2s infinite linear;
}

@keyframes myfirst {
0% {
  left: 0px;
  top: 6px;
}

25% {
  left: 0px;
  top: -6px;
}

50% {
  left: 0px;
  top: 6px;
}

75% {
  left: 0px;
  top: -6px;
}

100% {
  left: 0px;
  top: 6px;
}
}

>>>.el-carousel__mask {
  background:rgba(0,0,0,0.9);
  opacity: 0.4;
}
</style>

<style scoped lang="stylus">
@thePink :#e84d49;
.typer {
  margin-top: 2%;
  box-sizing: border-box;
}

.typer .typer-content {
  font-weight: bold;
  font-size: 50px;
  display: flex;
  flex-direction: row;
  letter-spacing: 2px;
}

.typer-dynamic {
  position: relative;
}

.cut {
  color: @thePink;
}

.typer-cursor {
  position: absolute;
  height: 100%;
  width: 3px;
  top: 0;
  right: -10px;
  background-color: @thePink;
  animation: flash 1.5s linear infinite;
}
</style>
